<template>
  <div>
    <div class="full-height" v-loading="rulesListReqStatus === 'loading'">
      <table-toolbar
        v-if="apiCalled"
        :key="rulesListData.key"
        :search-properties="visibleRuleslistColumns"
        :total-search-properties="ruleslistColumns"
        :search-data="rulesListData"
        :initial-tags="rulesListData.searchTags"
        :active-filter-data="activeFiltersData"
        :reload-component="rulesListData.reloadToolbar"
        :disable-search-box="disableSearchBox"
        @update-querydata="updateTableQueryData"
        @refresh-tabledata="refreshTableData"
        @update-columns-data="modifyColumnsData"
        @add-searchtags="addSearchTags"
        @deactivate-filter="deactivateFilter"
      >
        <div slot="left-toolbar-tools" class="filter-button-group">
          <span v-if="filterList.length">
            <div class="display-inline mr-18 relative-pos" v-for="(btn, index) in filterList" :key="index">
              <el-input
                ref="customFilterInput"
                class="filter-input"
                v-if="btn.editFlag"
                placeholder="+Name"
                v-model="btn.name"
                @change.native.stop="handleFilterNameChange(btn)"
                @keyup.native.enter="handleFilterNameChange(btn)"
                @blur="handleFilterNameChange(btn)"
              ></el-input>
              <el-button
                v-else
                size="small"
                round
                :class="{'active': btn.active}"
                :id="btn.id"
                @click="changeState(btn)"
              >
                {{ btn.name}}
                <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                <span>
                  <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                  <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                </span>
                </el-tooltip>
              </el-button>

              <span v-if="btn.errFlag" class="filter-name-validator">{{filterErrMsg}}</span>
            </div>
          </span>
        </div>
        <div slot="local-actions">
          <el-button-group>
            <!-- <el-tooltip class="item" effect="dark" content="Upload Ruleset" placement="top" :enterable="false">
              <el-button
                v-if="$allow('rules', 'write')"
                type="text"
                class="cursor-pointer"
                @click="openUploadRulesetDialog()"
              >
                <i class="material-icons c-icon">post_add</i>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Download Ruleset" placement="top" :enterable="false">
              <el-button
                v-if="$allow('rules', 'read')"
                type="text"
                class="cursor-pointer"
                @click="rulesListData.downloadCsv()"
              >
                <i class="material-icons c-icon">vertical_align_bottom</i>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Save Rules Override" placement="top" :enterable="false">
              <el-button
                v-if="$allow('rules', 'write')"
                type="text"
                class="cursor-pointer"
                @click="uploadOverrideDialogVisible = true"
              >
                <i class="material-icons c-icon">save</i>
              </el-button>
            </el-tooltip>-->
            <!-- <el-tooltip class="item" effect="dark" content="Mark as Privilege Rule" placement="top" :enterable="false">
              <el-button
                v-if="$allow('rules', 'write')"
                type="text"
                class="cursor-pointer"
                @click="openMarkPrivilegeRulesDialog"
              >
                <i class="material-icons c-icon">star</i>
              </el-button>
            </el-tooltip>-->
            <el-tooltip class="item" effect="dark" content="Enable/Disable Rule" placement="top" :enterable="false">
              <el-button
                v-if="$allow('rules', 'write')"
                type="text"
                class="cursor-pointer"
                :class="{
                  'display-none':
                    !allowRulesOverride ||
                    !displayTableActions.show ||
                    (!displayTableActions.singleSelect && !displayTableActions.multiselect)
                }"
                @click="openDisableRules"
              >
                <i class="material-icons c-icon">not_interested</i>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Rules Details" placement="top" :enterable="false">
              <el-button
                type="text"
                class="cursor-pointer"
                :class="{
                  'display-none': !displayTableActions.show && !displayTableActions.singleSelect,
                  disabled: displayTableActions.multiselect
                }"
                @click.stop.prevent="openDetails"
              >
                <i class="material-icons c-icon">info</i>
              </el-button>
            </el-tooltip>
          </el-button-group>
        </div>
      </table-toolbar>

      <multi-select-table-element
        class="rules-table"
        v-if="rulesListReqStatus == 'saved'"
        :columns="visibleRuleslistColumns"
        :table-data="rulesListData"
        :height-offset="60"
        :actions="tableActions"
        ref="rulesTable"
        @update-record-count="recordCountHandler"
        @table-selection-change="checkTableSelectionChanges"
      ></multi-select-table-element>
    </div>

    <aside-sidebar
      parent=".layout-container"
      sibling=".rules-table"
      v-model="hideRulesDetails"
      v-if="rulesListReqStatus == 'saved'"
    >
      <div slot="title">
        <h2 class="mv-0">{{ rulesSelected.name }}</h2>
      </div>
      <rules-details-feed slot="content" :rules-details="rulesSelected"></rules-details-feed>
    </aside-sidebar>

    <el-dialog title="Upload Master Ruleset" :visible.sync="uploadMasterRulesetDialogVisible">
      <el-form
        enctype="multipart/form-data"
        label-width="250px"
        label-position="left"
        :model="uploadRulesetForm"
        ref="uploadForm"
      >
        <el-form-item label="Ruleset version" prop="version">
          <el-autocomplete
            popper-class="my-autocomplete"
            placeholder="Version"
            v-model="uploadRulesetForm.version"
            :fetch-suggestions="getRevisions"
          >
            <i class="material-icons c-icon" slot="suffix">edit</i>
            <template slot-scope="{ item }">
              <div class="item">{{ item }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item label="Minimum supported agent version" prop="minAgentVersion">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="uploadRulesetForm.minAgentVersion"
            :fetch-suggestions="getAgentVersions"
            placeholder="Version"
          >
            <i class="material-icons c-icon" slot="suffix">edit</i>
            <template slot-scope="{ item }">
              <div class="value">{{ item.display }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item label="Ruleset file (.csv, .json)" prop="ruleset">
          <input
            id="ruleset_file"
            type="file"
            accept=".csv, .json"
            ref="rulesetFile"
            @change="handleFileUpload($event)"
          />
        </el-form-item>
      </el-form>
      <div v-if="!$_.isEmpty(uploadRulesetForm.errors)" class="error">
        <label v-for="(error, idx) in uploadRulesetForm.errors" :key="idx">{{ error }}</label>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUpload">Cancel</el-button>
        <el-button @click="submitUpload" type="primary">Upload</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Confirm Ruleset Save" :visible.sync="uploadOverrideDialogVisible">
      <p class="body1">
        This change will be reflected across the application and your organization.
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadOverrideDialogVisible = false">Cancel</el-button>
        <el-button @click="saveOverride" type="primary">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Mark as Privilege Rules"
      :visible.sync="markPrivilegeRuleDialogVisible"
      custom-class="privilege_confirm"
    >
      <p class="body1">
        When marking rule as privilege rule, the following changes will occur:
      </p>
      <span class="display-block">
        <i class="material-icons c-icon">check_box</i>
        <p class="body1 display-inline">
          It will not be part of the scoring system, therefore it will have a zero score.
        </p>
      </span>
      <span class="display-block">
        <i class="material-icons c-icon">check_box</i>
        <p class="body1 display-inline">
          It will move to the Privileged Activities tab from the Rules view.
        </p>
      </span>
      <span class="display-block">
        <i class="material-icons c-icon">check_box</i>
        <p class="body1 display-inline">
          Any activity trigged by these rules will be considered Privileged Activities, not Threat Detections.
        </p>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="markPrivilegeRuleDialogVisible = false">Cancel</el-button>
        <el-button @click="markAsPrivilegeRules" type="primary">Mark as Privilege Rules</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Enable/Disable Rules" :visible.sync="disableRuleDialogVisible">
      <el-switch v-model="enableDisableRuleToggle.model" :active-text="'Enable'" :inactive-text="'Disable'"></el-switch>
      <p class="body1">
        Are you sure you want to make changes to the selected rules?
      </p>
      <div v-if="enableDisableRuleToggle.error" class="error">
        <label>{{ enableDisableRuleToggle.error }}</label>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="disableRuleDialogVisible = false">Cancel</el-button>
        <el-button @click="enableDisableRulesFn" type="primary">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Papa from 'papaparse'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import BasicTableElement from '@/components/table/BasicTableElement.vue'
import MultiSelectTableElement from '@/components/table/MultiSelectTableElement.vue'
import ActionTableElement from '@/components/table/ActionTableElement.vue'
import { rulesListMetaInfo } from '@/column-header/rules/ruleslist-meta'
import {
  RULES_LIST_REQ,
  RULES_LIST_SUCCESS,
  MASTER_RULESET_UPLOAD,
  OVERRIDE_RULESET_UPLOAD,
  THREAT_PROGRESSION_VIEW_PREFERENCES_REQ,
  SAVE_THREAT_PROGRESSION_VIEW_PREFERENCES
} from '@/store/modules/rules/rules.type'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'
import { MITRE_TACTIC_LIST_REQ, MITRE_TECHNIQUE_LIST_REQ } from '@/store/modules/mitre-attack/mitre-attack.type'
import AsideSidebar from '@/components/layout/AsideSidebar.vue'
import RulesDetailsFeed from '@/components/feed/RulesDetailsFeed.vue'
import customFilterMixin from '@/mixins/customFilterMixin'

export default {
  name: 'Rules',
  mixins: [customFilterMixin],
  data () {
    return {
      threatProgressionColumnPrefs: {},
      tableName: "Threat_Progressions",
      breadcrumbs: [{ title: 'Security Posture' }, { title: 'Rules' }],
      ruleslistColumns: rulesListMetaInfo.meta.columns,
      // visibleRuleslistColumns: rulesListMetaInfo.meta.columns,
      visibleRuleslistColumns: [],
      originalRulesListData: [],
      rulesListData: {},
      rulesSelected: {},
      apiCalled: false,
      hideRulesDetails: true,
      uploadMasterRulesetDialogVisible: false,
      uploadOverrideDialogVisible: false,
      disableRuleDialogVisible: false,
      markPrivilegeRuleDialogVisible: false,
      enableDisableRuleToggle: {
        model: false,
        error: ''
      },
      uploadRulesetForm: {
        version: '',
        minAgentVersion: '',
        errors: []
      },
      uploadRulesetFieldValidation: {
        version: [
          {
            required: true,
            message: 'Please provide version number.',
            trigger: 'blur'
          }
        ],
        minAgentVersion: [
          {
            required: true,
            message: 'Please provide the minimum agent version.',
            trigger: 'blur'
          }
        ],
        ruleset: [
          {
            required: true,
            message: 'Please provide the ruleset to upload.',
            trigger: 'blur'
          }
        ]
      },
      tableActions: [
        {
          name: 'info',
          icon: 'material-icons c-icon',
          iconSubject: 'info',
          tooltip: 'Rules Details',
          rbac: {
            subject: 'rules',
            operation: 'read'
          },
          actionHandler: selection => {
            this.rulesSelected = selection.row
            this.hideRulesDetails = false
          }
        }
      ],
      displayTableActions: {
        show: false,
        singleSelect: false, // only enabled for 1 row
        multiselect: false // enabled for 1 or more row
      },
      tblId: 9
    }
  },
  created () {
    if (this.mitreTacticListReqStatus !== 'saved') {
      Promise.all([this.$store.dispatch(MITRE_TACTIC_LIST_REQ), this.$store.dispatch(MITRE_TECHNIQUE_LIST_REQ)]).then(
        values => {}
      )
    }
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    this.callApi(tableMetaData)

    this.loadThreatProgressionColumnPreferences()
  },
  methods: {
    checkTableSelectionChanges () {
      if (_.isEmpty(this.$refs.rulesTable.rowsSelected)) {
        this.displayTableActions.show = false
        this.displayTableActions.singleSelect = false
        this.displayTableActions.multiselect = false
      } else if (this.$refs.rulesTable.rowsSelected.length === 1) {
        this.displayTableActions.show = true
        this.displayTableActions.singleSelect = true
        this.displayTableActions.multiselect = false
      } else {
        this.displayTableActions.show = true
        this.displayTableActions.singleSelect = false
        this.displayTableActions.multiselect = true
      }
    },
    openDetails () {
      if (_.isEmpty(this.$refs.rulesTable.rowsSelected) || this.$refs.rulesTable.rowsSelected.length > 1) {
        return false
      }
      this.rulesSelected = _.cloneDeep(this.$refs.rulesTable.rowsSelected[0])
      this.hideRulesDetails = false
    },
    openMarkPrivilegeRulesDialog () {
      if (_.isEmpty(this.$refs.rulesTable.rowsSelected)) {
        return false
      }
      this.markPrivilegeRuleDialogVisible = true
    },
    openDisableRules () {
      if (_.isEmpty(this.$refs.rulesTable.rowsSelected)) {
        return false
      }
      this.enableDisableRuleToggle.model = false
      this.enableDisableRuleToggle.error = ''
      this.disableRuleDialogVisible = true
    },
    openUploadRulesetDialog () {
      this.uploadMasterRulesetDialogVisible = true
    },
    getRevisions (queryString, callback) {
      if (queryString) {
        callback(
          _.filter(this.rulesRevisionsList, revision => {
            return revision.includes(queryString)
          })
        )
      } else {
        callback(this.rulesRevisionsList)
      }
    },
    getAgentVersions (queryString, callback) {
      let agents = [
        { value: '1.0', display: '1.0' },
        { value: '1.1', display: '1.1' },
        { value: '1.2', display: '1.2' }
      ]
      if (queryString) {
        callback(
          _.filter(agents, agent => {
            return agent.display.includes(queryString)
          })
        )
      } else {
        callback(agents)
      }
    },
    handleFileUpload (event) {
      let file = this.$refs.rulesetFile.files[0]
      // parse only if a file is selected
      if (file) {
        let reader = new FileReader()
        reader.readAsText(file, 'UTF-8')
        reader.onload = evt => {
          this.uploadRulesetForm.errors.length = 0
          if (file.type === 'text/csv') {
            let csvToJSON = Papa.parse(evt.target.result, {
              header: true,
              skipEmptyLines: 'greedy'
            })
            if (_.isEmpty(csvToJSON.errors)) {
              this.uploadRulesetForm.ruleset = csvToJSON.data
              console.log(csvToJSON)
            } else {
              csvToJSON.errors.forEach(error => {
                // account for 0 index
                this.uploadRulesetForm.errors.push(`Row ${error.row + 1}: ${error.message}`)
              })
            }
          } else if (file.type === 'application/json') {
            try {
              let jsonData = JSON.parse(evt.target.result)
              this.uploadRulesetForm.ruleset = jsonData
            } catch (error) {
              console.log('JSON parser error reading file')
              this.uploadRulesetForm.errors.push(`${error}`)
            }
          }
        }
        reader.onerror = evt => {
          console.error(evt)
        }
      }
    },
    submitUpload () {
      this.$refs['uploadForm'].validate(valid => {
        if (valid) {
          this.$store
            .dispatch(MASTER_RULESET_UPLOAD, {
              version: this.uploadRulesetForm.version,
              minAgentVersion: this.uploadRulesetForm.minAgentVersion,
              ruleset: this.uploadRulesetForm.ruleset,
              rulesetFile: this.$refs.rulesetFile.files[0]
            })
            .then(
              resp => {
                this.refreshTableData({
                  activePage: this.rulesListData.currentPage,
                  searchTags: this.rulesListData.searchTags
                })
                this.cancelUpload()
              },
              errMsg => {
                let err = errMsg.data ? errMsg.data.message : 'Error occurred'
                this.$set(this, 'userFormError', err)
                console.log('error occurred')
              }
            )
        }
      })
    },
    cancelUpload () {
      this.uploadMasterRulesetDialogVisible = false
      this.uploadRulesetForm.version = ''
      this.uploadRulesetForm.minAgentVersion = ''
      this.uploadRulesetForm.errors.length = 0
      // reset file input element
      this.$el.querySelector('#ruleset_file').value = ''
      this.$refs['uploadForm'].resetFields()
    },
    markAsPrivilegeRules () {
      let overrides = _.cloneDeep(this.$refs.rulesTable.rowsSelected)
      overrides.forEach(override => {
        override.score = 'ZERO'
      })
      this.$store.dispatch(OVERRIDE_RULESET_UPLOAD, { ruleset: overrides }).then(
        result => {
          this.refreshTableData({
            activePage: this.rulesListData.currentPage,
            searchTags: this.rulesListData.searchTags
          })
          this.markPrivilegeRuleDialogVisible = false
        },
        errMsg => {}
      )
    },
    enableDisableRulesFn () {
      let overrides = _.cloneDeep(this.$refs.rulesTable.rowsSelected)
      overrides.forEach(override => {
        override.enabled = this.enableDisableRuleToggle.model
      })
      this.$store.dispatch(OVERRIDE_RULESET_UPLOAD, { ruleset: overrides }).then(
        result => {
          this.refreshTableData({
            activePage: this.rulesListData.currentPage,
            searchTags: this.rulesListData.searchTags
          })
          this.disableRuleDialogVisible = false
          this.$message({
            type: 'success',
            message: `Rules were successfully ${this.enableDisableRuleToggle.model ? 'enabled' : 'disabled'}.`
          })
        },
        errMsg => {
          this.enableDisableRuleToggle.error = `Failed to update rule changes.`
        }
      )
    },
    saveOverride () {
      let overrides = _.differenceWith(this.rulesListData.models, this.originalRulesListData, _.isEqual)
      this.$store.dispatch(OVERRIDE_RULESET_UPLOAD, { ruleset: overrides }).then(
        result => {
          this.refreshTableData({
            activePage: this.rulesListData.currentPage,
            searchTags: this.rulesListData.searchTags
          })
          this.uploadOverrideDialogVisible = false
        },
        errMsg => {}
      )
    },
    updateTableQueryData () {
      if (this.$refs.rulesTable) {
        this.$refs.rulesTable.updateTableData()
      }
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.rulesListData.key = !this.rulesListData.key
      this.rulesListData.reloadToolbar = false
    },
    modifyColumnsData (selectedColumns) {
      this.threatProgressionColumnPrefs.userId = this.userProfile.id;
      this.threatProgressionColumnPrefs.tblName = this.tableName;
      this.threatProgressionColumnPrefs.preferedCols = selectedColumns.length === 0? NaN: selectedColumns;
      this.threatProgressionColumnPrefs.tblId = 9; // For Mapping with database tables

      this.visibleRuleslistColumns = this.rulesListData.updateVisibleColumns(this.ruleslistColumns, selectedColumns)

      // store preferences in db
      this.$store.dispatch(SAVE_THREAT_PROGRESSION_VIEW_PREFERENCES, this.threatProgressionColumnPrefs)
        .then(data => {
          // store preferences in vuex
          this.threatProgressionColumnPrefs.preferedCols = this.visibleRuleslistColumns;
          this.$store.dispatch(PREFERENCE_STORE_REQ, this.threatProgressionColumnPrefs);
        })
    },
    callApi (tableMetaData) {
      this.$store.dispatch(RULES_LIST_REQ).then(rules => {
        this.apiCalled = true
        this.originalRulesListData = _.cloneDeep(this.rulesList.models)
        this.rulesListData = this.rulesList
        this.$store.dispatch(RULES_LIST_SUCCESS)
        this.setTableMetaData(tableMetaData)
      })
    },
    setTableMetaData (tableMetaData) {
      this.rulesListData.searchTags = tableMetaData.searchTags
      this.rulesListData.currentPage = tableMetaData.activePage
    },
    refreshTableData (tableMetaData) {
      this.apiCalled = false
      this.callApi(tableMetaData)
    },
    loadThreatProgressionColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleRuleslistColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(THREAT_PROGRESSION_VIEW_PREFERENCES_REQ, this.userProfile.id)
          .then(data => {
            this.visibleRuleslistColumns = this.ruleslistColumns.filter(col => {
              return this.threatProgressionPreferences.includes(col.label)
            })
            this.updateStoreWithPrefs()
          })
      }
    },
    updateStoreWithPrefs () {
      this.threatProgressionColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleRuleslistColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.threatProgressionColumnPrefs);
    }
  },
  computed: {
    ...mapGetters([
      'rulesListReqStatus',
      'rulesList',
      'agentListReqStatus',
      'rulesRevisionsList',
      'rulesRevisionsListReqStatus',
      'allowRulesOverride',
      'mitreTacticListReqStatus',
      'threatProgressionPreferences',
      'userProfile',
      'userPref'
    ])
  },
  components: {
    PageHeaders,
    BasicTableElement,
    MultiSelectTableElement,
    TableToolbar,
    AsideSidebar,
    RulesDetailsFeed,
    ActionTableElement
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.table-toolbar {
  .el-button:last-of-type {
    .c-icon {
      border-left: 1px solid var(--border-color);
      padding-left: 10px;
    }
  }
}

.privilege_confirm {
  .c-icon {
    font-size: 14px;
  }
}

.error {
  label {
    display: block;
    text-align: center;
    color: var(--text-color-danger) !important;
  }
}

.disabled {
  color: var(--tuna-400);
  cursor: not-allowed;
  .c-icon {
    color: var(--tuna-400);
  }
}

>>> .el-dialog {
  .body1 {
    word-break: normal;
  }
}

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  right: 8%;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/rules/Rules.vue